export const LocationAutocomplete = {
    REQUEST_LOCATION_AUTOCOMPLETE: 'REQUEST_LOCATION_AUTOCOMPLETE',
    RECEIVE_LOCATION_AUTOCOMPLETE: 'RECEIVE_LOCATION_AUTOCOMPLETE',
    FAIL_LOCATION_AUTOCOMPLETE: 'FAIL_LOCATION_AUTOCOMPLETE',
    REQUEST_HOTEL_LOCATION_AUTOCOMPLETE: 'REQUEST_HOTEL_LOCATION_AUTOCOMPLETE',
    RECEIVE_HOTEL_LOCATION_AUTOCOMPLETE: 'RECEIVE_HOTEL_LOCATION_AUTOCOMPLETE',
    REQUEST_HOTEL_LOCATION_AUTOCOMPLETE_V2: 'REQUEST_HOTEL_LOCATION_AUTOCOMPLETE_V2',
    RECEIVE_HOTEL_LOCATION_AUTOCOMPLETE_V2: 'RECEIVE_HOTEL_LOCATION_AUTOCOMPLETE_V2',
    REQUEST_DP_LOCATION_AUTOCOMPLETE_GEOREGION: 'REQUEST_DP_LOCATION_AUTOCOMPLETE_GEOREGION',
    RECEIVE_DP_LOCATION_AUTOCOMPLETE_GEOREGION: 'RECEIVE_DP_LOCATION_AUTOCOMPLETE_GEOREGION',
};
